<template>
	<Select v-if="cellEditing || cellEditable"
	    v-bind="$attrs"
	    v-on="editEvents"
	    transfer
        :readonly="!cellEditing || $attrs.readonly"
	    :class="prefixCls + '-select'"
	    :value="value"
	    @input="onChange">
		<Option v-for="(item, index) in options"
		    :value="item.id"
		    :key="item.id">
			{{item.text}}
		</Option>
	</Select>
	<cell-render v-else-if="render"
	    :render="render"
	    :context="$props"></cell-render>
    
	<div v-else :class="prefixCls + '-wrap-readonly'"
		data-cls="cell-content">
		<slot>
			<span>{{ currentText }}</span>
		</slot>
	</div>
</template>
<script>
import mixin from './mixin'
import Input from '../input'
import Select from '../select'
import { Option } from '../select'

export default {
	mixins: [mixin],

	props: {
		optionList: {
			type: [Array, Function],
			default: () => []
		}
	},

	components: {
		Select,
        Option,
        Input
	},

	name: "CellSelect",

	computed: {
		options() {
			var list = this.optionList

			if (typeof list == "function") {
				list = list(this.getContext())
			}

			return list
		},

		currentText() {
			var t = this.options.find(v => v.id == this.value)

			// 找不到默认展示其value
			return t ? t.text : this.value
		}
	},
}
</script>